import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export enum SCREEN {
  OFFER,
  APPLICATION,
  OTPSCREEN,
  CONFIRM,
  TRANSITION,
  ERROR,
  ASYNC_APP_TIMEOUT,
  STATUS,
  ACCEPT,
  ONE_TIME_PAYMENT,
  ACCOUNT,
  DOCUMENTS,
  LOGIN,
  DOB,
  PIN,
  SERVICE_OTPSCREEN,
  VERIFICATION_FAILED,
  ACCOUNT_PENDING,
  INCOME_HOUSING_MODAL,
  DUPLICATE_APP,
  APPLICATION_IN_REVIEW,
  APPLICATION_NOT_APPROVED,
  CREDIT_FROZEN,
  APPLICATION_EXPIRED,
  APPLICATION_ACTIVE_USER,
  APPLICATION_OFFER_NOT_ACCEPTED,
  FIND_ACCOUNT_REQUIRED,
  ACCOUNT_LOCKED,
  STATUS_OTP_VERIFICATION_FAILED,
  CREATE_PIN,
  COMPLETE_ON_PHONE,
}

export interface ScreenState {
  screen: SCREEN;
}

const initialState: ScreenState = {
  screen: SCREEN.APPLICATION,
};

const screenStateSlice = createSlice({
  name: 'screenState',
  initialState,
  reducers: {
    setScreen: (state, action: PayloadAction<SCREEN>) => {
      state.screen = action.payload;
    },
  },
});

export const { setScreen } = screenStateSlice.actions;
export default screenStateSlice.reducer;
